import { Component, Input, OnInit } from '@angular/core'
import { Order } from '@spartacus/order/root'
import { OrderStatus } from '../../../models/enum/order.enum'
import { OrderHistoryService } from '../../../services/order-history.service'

@Component({
    selector: 'app-order-status',
    templateUrl: './order-status.component.html',
    styleUrls: ['./order-status.component.scss'],
    standalone: false
})
export class OrderStatusComponent implements OnInit {
  @Input() order: Order
  @Input() forceStatus: OrderStatus

  constructor(public orderHistoryService: OrderHistoryService) {}

  ngOnInit(): void {}
}
